import TextMuted from './TextMuted'

export default TextMuted
